import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';
import { trackPromoNewbuildingListingClickAction } from '../../actions/analytics';
import { NewbuildingsLink } from '../../components/NewbuildingsLink';
import { TThunkDispatch } from '../../types/redux/thunk';

interface INewbuildingLinkContainerProps {
  desktopUrl: string;
  mobileUrl: string;
  promoId: string;
  label?: string;
}

export const NewbuildingLinkContainer = ({ desktopUrl, mobileUrl, promoId, label }: INewbuildingLinkContainerProps) => {
  const deviceType = useDeviceType();
  const dispatch: TThunkDispatch = useDispatch();

  const handleLinkClick = React.useCallback(() => {
    dispatch(trackPromoNewbuildingListingClickAction(promoId));
  }, [dispatch, promoId]);

  const newbuildingsUrl = deviceType === 'desktop' ? desktopUrl : mobileUrl;

  const linkLabel = deviceType !== 'desktop' && !label ? 'Смотреть объявления' : label;

  return <NewbuildingsLink onClick={handleLinkClick} url={newbuildingsUrl} label={linkLabel} />;
};
